<div class="nav-links" [ngClass]="{ 'p-3': !iconOnly() }">
  @for (item of navigationItems(); track item.id) {
    <a
      [routerLink]="item.path"
      [routerLinkActive]="item.path ? 'active' : ''"
      class="nav-link"
      [routerLinkActiveOptions]="{ exact: item.exact ?? false }"
      [ngbTooltip]="iconOnly() ? (item.label | translate) : null"
      [class.cursor-pointer]="item.action && !item.path"
      (click)="item.action ? action.emit(item.id) : null"
    >
      @if (item.icon) {
        <i class="{{ item.icon }}" [ngClass]="!iconOnly() ? 'me-2' : ''"></i>
      }
      @if (!iconOnly()) {
        <span>{{ item.label | translate }}</span>
      }
    </a>
  }
</div>
